// base
import React from 'react';

// style
import { StyledAlertModalV2 } from './style';

// components
import { CenterModal, TextButton } from 'components';

export interface AlertModalV2Props {
  desc?: React.ReactNode;
  onClose: () => void;
  modalTitle?: string;
  isSigleBtn?: boolean;
  onOk?: () => void;
  open?: boolean;
  noMinWidth?: boolean;
}

export const AlertModalV2: React.FC<AlertModalV2Props> = ({
  desc,
  open = false,
  onClose,
  modalTitle = 'Warning',
  isSigleBtn = false,
  onOk,
  noMinWidth = true,
  ...props
}) => {
  return (
    <CenterModal
      open={open}
      onClose={onClose}
      closeAfterTransition
      modalTitle={modalTitle}
      footer={false}
      {...props}
    >
      <StyledAlertModalV2 $noMinWidth={noMinWidth}>
        <p>{desc}</p>

        <div
          className="btn-wrapper"
          style={{
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'end',
            gap: 14
          }}
        >
          <TextButton onClick={onOk} variant="contained">
            Ok
          </TextButton>
          {!isSigleBtn && (
            <TextButton onClick={onClose} variant={isSigleBtn ? 'contained' : 'text'}>
              Close
            </TextButton>
          )}
        </div>
      </StyledAlertModalV2>
    </CenterModal>
  );
};
